// extracted by mini-css-extract-plugin
export default {"coevaluationItem":"IndividualCoevaluation_coevaluationItem__VJNDP","textField":"IndividualCoevaluation_textField__NNM7f"};